import { Participante } from './participante.model';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ProcessoMovimentacao } from './processo-movimentacao';

export class MeAvise {

  Id: number;
  UsuarioPodeEditar: boolean;
  UsuarioPodeEditarDescricao: boolean;
  UsuarioPodeRealizar: boolean;
  UsuarioPodeDesrealizar: boolean;
  ProcessoId: number;
  ProcessoMovimentacaoId: number;
  ProcessoMovimentacao: ProcessoMovimentacao;

  TipoMovimentacaoId: number;

  Descricao: string;

  UsuarioAtualId?: number;
  UsuarioAtual: string;
  UsuarioCriacao: Participante;
  UltimoUsuarioTransferiu: string;
  DataUltimaTransferencia: string;


  DataInsercao: string;
  Data: string;
  Prazo: string;
  PrazoDias: number;
  PrazoInterno: string;
  PrazoFatal: string;

  RealizadoUsuarioId: number;
  RealizadoUsuario: string;
  RealizadoData: string;
  Realizado: boolean;

  ProtocoladoUsuarioId: number;
  ProtocoladoData: string;
  Protocolado: boolean;

  ProtocoloSemPrazo: boolean = false;

  Agenda: boolean;
  Destaque: boolean;
  Horario: string;
  HorarioAgenda: string;

  Transferencias: MeAviseTransferencia[] = [];

  MeAviseTipoId?: number;
  MeAviseTipo: string;

  Audiencia: boolean;

  Ativo: boolean;

  constructor(data: string = '') {
    this.Id = 0;
    this.UsuarioAtualId = null;
    this.MeAviseTipoId = null;
    this.Descricao = '';

    const agora = new Date;
    let minutoAgora = agora.getMinutes();
    let horaAgora = agora.getHours();
    minutoAgora = minutoAgora + 30;
    if (minutoAgora >= 60) {
      minutoAgora = minutoAgora - 60;
      horaAgora = horaAgora + 1;
    }
    const hora = UtilitarioService.adicionaZero(horaAgora);
    const minuto = UtilitarioService.adicionaZero(minutoAgora);
    this.Horario = hora + ':' + minuto;

    if (data === undefined || data == null || data === '') {
      this.Data = UtilitarioService.retornaDataAtualMaisDiasISO(0);
      this.Prazo = '';
    } else {
      this.Data = data;
      this.Prazo = '';
    }

    //this.Data = this.Data.replaceAll('/','-');
  }
}

export class MeAviseTransferencia {
  Id: number;
  MeAviseId: number;
  UsuarioTransferiuId: number;
  UsuarioTransferiu: string;
  UsuarioTransferiuNome: string;
  DataTransferencia: Date;
  UsuarioNovoId: number;
  UsuarioNovoNome: string;
  UsuarioNovo: string;
  UsuarioAntigoId: number;
  UsuarioAntigoNome: string;
  UsuarioAntigo: string;
  DataAntiga: Date;
  DescricaoAntigaNome: string;
  PrazoAntigo: Date;
  PrazoInternoAntigo: Date;
  PrazoFatalAntigo: Date;
  NovaData?: Date;
}
